import styled from 'styled-components'

export default styled.div`
position: absolute;
z-index: 2;
width: 100%;
height: 100%;
background-color: rgb(122, 161, 178, 0.2);
border-radius: 50%;
`
